/*
 * @Author: 肖玲
 * @Date: 2023-02-28 16:19:47
 * @LastEditTime: 2023-02-28 18:35:19
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-import\modules\flowDirectionImportRouter.js
 * 流向导入路由
 */
const flowDirectionImportRouter = [
  // 销售数据导入
  {
    path: '/flowSystem/fs-sales-data-import/:meta_type',
    name: 'flowSystemSalesDataImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '@/views/flowSystem/SalesDataImport.vue'
      // ),  待删除文件
    import(
      /*webpackChunkName:"flowSystemConfig3" */
      '@/views/butterfly-flow-system/flow-direction-import/flow-direction-import/sales-data-import/Page.vue'
    ),  //新迁移文件
    meta: {
      SecondaryMenu: '流向导入', //二级菜单
      isMoreMeta: true,
      1: {
        title: '销售数据导入',
      },
      2: {
        title: '库存数据导入',
      },
      3: {
        title: '采购数据导入',
      },
      4: {
        title: '销售数据导入',
        breadcrumb: [{
          title: '工业发货',
          name: 'behaviorManageIndustrialDeliver',
        }, ],
      },
    },
  },
  // 流向导入记录
  {
    path: '/flowSystem/flow-upload-page/:data_type',
    name: 'flowUploadLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem1" */
      //   '@/views/flowSystem/FlowUploadLog.vue'
      // ),  待删除文件
    import(
      /*webpackChunkName:"flowSystem1" */
      '@/views/butterfly-flow-system/flow-direction-import/flow-direction-import/sales-data-import/Import.vue'
    ),  //新迁移文件
    meta: {
      SecondaryMenu: '流向导入记录', //二级菜单
      title: '流向导入记录',
      1: [{
        title: '销售数据导入',
        name: 'flowSystemSalesDataImport',
        data_type: '1',
      }, ],
      2: [{
        title: '库存数据导入',
        name: 'flowSystemSalesDataImport',
        data_type: '2',
      }, ],
      3: [{
        title: '采购数据导入',
        name: 'flowSystemSalesDataImport',
        data_type: '3',
      }, ],
    },
  },
]
export default flowDirectionImportRouter